module.exports = __webpack_public_path__ + "img/map-general.08e36fea.jpg";